if (!customElements.get('header-active-menu')) {
  class HeaderActiveMenu extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('[id^="shopify-section-"]');
      if (!this.section) return;

      this.updateActiveMenuItem = this.updateActiveMenuItem.bind(this);
      this.updateActiveMenuItem();
      window.addEventListener('hashchange', this.updateActiveMenuItem);
    }

    disconnectedCallback() {
      window.removeEventListener('hashchange', this.updateActiveMenuItem);
    }

    normalizePath(path) {
      return path.replace(/\/+$/, '') || '/';
    }

    updateActiveMenuItem() {
      const currentPath = this.normalizePath(window.location.pathname);
      const currentHash = window.location.hash;
      const items = Array.from(this.section.querySelectorAll('[data-active-menu-item-url]')).map((item) => {
        item.classList.toggle('active', item.dataset.activeMenuItemDefault === 'true');
        return {
          element: item,
          url: new URL(item.dataset.activeMenuItemUrl, window.location.origin)
        };
      });
      const samePathItems = items.filter((item) => this.normalizePath(item.url.pathname) === currentPath);
      const hasHashMatch = currentHash && samePathItems.some((item) => item.url.hash === currentHash);

      samePathItems.forEach((item) => {
        if (hasHashMatch) {
          item.element.classList.toggle('active', item.url.hash === currentHash);
        } else if (item.url.hash) {
          item.element.classList.remove('active');
        }
      });
    }
  }

  customElements.define('header-active-menu', HeaderActiveMenu);
}
